import { type Listing } from '@/features/listing/types/listing-types';
import {
  type Conversation,
  type FileType,
} from '@/features/messages/types/conversation-types';
import { getUserBearerCookie } from '@/features/user/cookies/cookie-user-bearer';
import { type User } from '@/features/user/types/user-types';
import sendHttpError from '@/libs/logger/requests/send-http-error';
import { type MessageSentSource } from '@/shared/types/report-types';

export interface CreateMessageAttachment {
  name: string;
  value: string;
  type: FileType;
}

interface CreateMessageData {
  listingId?: Listing['id'],
  message: string,
  recipientId?: User['id'],
  conversationId?: Conversation['conversationID'],
  messageSrc?: MessageSentSource,
  attachments?: CreateMessageAttachment[],
}

// TODO: move to share folder
export default async function createMessage({
  attachments,
  conversationId,
  listingId,
  message,
  messageSrc,
  recipientId,
}: CreateMessageData) {
  const url = `${process.env.NEXT_PUBLIC_API_URL}/v1/messages`;
  const bearerToken = getUserBearerCookie();

  const headers: HeadersInit = { 'Content-Type': 'application/json' };

  if (bearerToken) {
    headers.Authorization = `Bearer ${bearerToken}`;
  }

  // {
  //   "message_text": "empty",
  //   "conversation": "682cc81fe23c6ddea258d240",
  //   "pushtosocket": false,
  //   "attachments": [
  //   {
  //     "name": "screencapture-localhost-3000-account-payments-2025-05-07-02_36_10.png",
  //     "value": "https://d2w0a6wbaasgww.cloudfront.net/attachments/new213hj3211749461987694screencapture-localhost-3000-account-payments-2025-05-07-02_36_10.png",
  //     "type": "Image"
  //   }
  // ],
  //   "src": "mailbox"
  // }

  // console.log('====> attachments !!!:', attachments);

  // TODO: Change type form any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const messageData: Record<string, any> = {
    message_text: message,
    pushtosocket: false,
    ...(messageSrc && { src: messageSrc }),
    ...(recipientId && { recipient_user_id: recipientId }),
    ...(conversationId && { conversation: conversationId }),
    ...(messageSrc === 'mailbox' && { attachments: attachments ?? null }),
  };

  if (listingId) {
    messageData.listing_id = listingId;
  }

  const createMessageResponse = await fetch(url, {
    body: JSON.stringify(messageData),
    cache: 'no-store',
    headers,
    method: 'POST',
  });

  if (!createMessageResponse.ok) {
    sendHttpError({
      baseName: `Send message ${messageSrc ?? ''}`,
      body: messageData,
      functionName: 'createMessage',
      method: 'POST',
      requestHeaders: headers,
      statusCode: createMessageResponse.status,
      url,
    });

    throw new Error('Failed to create message');
  }

  return createMessageResponse.ok;
}
